<style lang="scss" scoped>
/* 保险绑定弹窗（列表风格对齐项目） */
.policy-summary {
    display: flex;
    flex-wrap: wrap;
    gap: 12px 24px;
    margin-bottom: 20px;
    overflow-wrap: anywhere;
}

.asset-pagination {
    margin-top: 16px;
    overflow-x: auto;
}
</style>

<style lang="scss">
/* append-to-body 弹窗脱离组件作用域：宽度由 c-el-dialog(96%) 自适应，修饰类单独封顶 */
.asset-dialog--bindings { max-width: 960px; }
.asset-dialog--binding { max-width: 560px; }
.asset-dialog--ending { max-width: 430px; }
</style>

<template>
    <el-dialog :title="title" :visible.sync="visible" append-to-body custom-class="c-el-dialog asset-dialog asset-dialog--bindings">
        <div v-if="policy" class="policy-summary">
            <span>保险公司：{{ policy.company || '-' }}</span>
            <span>被保险人：{{ policy.insuredName || '-' }}</span>
            <span>保单期间：{{ date(policy.startDate) }} 至 {{ date(policy.endDate) }}</span>
            <span v-if="policy.remark">备注：{{ policy.remark }}</span>
        </div>
        <!-- 弹窗内工具栏：左侧新增绑定，右侧筛选/查询/导出 -->
        <div class="toolbars mrgb5">
            <div class="buttons mrgb5">
                <div class="fl">
                    <el-button v-if="canManage" class="mrgb5" type="primary" size="medium" @click="edit()"><i class="fa fa-plus"></i> 新增绑定</el-button>
                </div>
                <div class="fr">
                    <!-- 从保单进入时按车架号筛选，从车架进入时按保单号筛选 -->
                    <el-input v-if="context.policyNumber" class="c-el-input mrgr5 mrgb5" size="medium" clearable v-model.trim="query.chassisNo" placeholder="车架号"></el-input>
                    <el-input v-else class="c-el-input mrgr5 mrgb5" size="medium" clearable v-model.trim="query.policyNumber" placeholder="保单号"></el-input>
                    <el-select class="c-el-input short-input mrgr5 mrgb5" size="medium" v-model="query.currentOnly" placeholder="绑定范围" @change="search">
                        <el-option label="全部历史" :value="false"></el-option>
                        <el-option label="当前有效" :value="true"></el-option>
                    </el-select>
                    <el-button class="mrgr5 mrgb5" type="primary" size="medium" @click="search()"><i class="fa fa-search"></i> 查询</el-button>
                </div>
                <div class="clearb"></div>
            </div>
        </div>
        <el-table v-loading="loading" :data="rows" style="width: 100%" border size="medium" max-height="430">
            <el-table-column prop="chassisNo" label="车架号" min-width="190" />
            <el-table-column prop="policyNumber" label="保单号" min-width="190" />
            <el-table-column prop="company" label="保险公司" min-width="130" />
            <el-table-column prop="insuranceArea" label="保险区域" min-width="140" />
            <el-table-column label="绑定开始" width="110"><template slot-scope="scope">{{ date(scope.row.startDate) }}</template></el-table-column>
            <el-table-column label="绑定结束" width="110"><template slot-scope="scope">{{ date(scope.row.endDate) }}</template></el-table-column>
            <el-table-column label="有效截止" width="110"><template slot-scope="scope">{{ date(scope.row.effectiveEndDate) }}</template></el-table-column>
            <el-table-column label="状态" width="95"><template slot-scope="scope"><el-tag size="medium" :type="scope.row.isActive ? 'success' : 'info'">{{ scope.row.isActive ? '当前有效' : '非当前' }}</el-tag></template></el-table-column>
            <el-table-column label="操作" width="100" :fixed="assetMobile ? false : 'right'">
                <template slot-scope="scope">
                    <el-dropdown trigger="click">
                        <el-button type="primary" plain size="mini">更多<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-if="canManage" @click.native="edit(scope.row)">编辑绑定</el-dropdown-item>
                            <el-dropdown-item v-if="canManage" @click.native="openEnd(scope.row)">结束绑定</el-dropdown-item>
                            <el-dropdown-item v-if="canManage" @click.native="remove(scope.row)">删除绑定</el-dropdown-item>
                            <el-dropdown-item v-if="canLogs" @click.native="showLogs(scope.row)">变更日志</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="asset-pagination" background :current-page.sync="query.page" :page-size.sync="query.size" :page-sizes="appPageSizes" :total="total" layout="total, sizes, prev, pager, next" @current-change="load" @size-change="search"></el-pagination>
        <el-dialog :title="form.id ? '编辑绑定' : '新增绑定'" :visible.sync="editing" append-to-body custom-class="c-el-dialog asset-dialog asset-dialog--binding" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small" @submit.native.prevent="save">
                <el-form-item label="车架号" prop="chassisNo"><el-input v-model.trim="form.chassisNo" :disabled="!!form.id" :maxlength="32" /></el-form-item>
                <el-form-item label="保单号" prop="policyNumber">
                    <el-select v-model="form.policyNumber" :disabled="!!form.id" filterable remote :remote-method="searchPolicies" :loading="policyLoading" @change="changePolicy">
                        <el-option v-for="item in policies" :key="item.id || item.policyNumber" :label="item.policyNumber" :value="item.policyNumber" />
                    </el-select>
                </el-form-item>
                <el-form-item label="保险区域"><el-input v-model.trim="form.insuranceArea" :maxlength="200" /></el-form-item>
                <el-form-item label="开始日期" prop="startDate"><el-date-picker v-model="form.startDate" :disabled="!!form.id" type="date" value-format="yyyy-MM-dd" /></el-form-item>
                <el-form-item label="结束日期" prop="endDate"><el-date-picker v-model="form.endDate" type="date" value-format="yyyy-MM-dd" clearable /></el-form-item>
            </el-form>
            <span slot="footer"><el-button :disabled="saving" @click="editing = false">取消</el-button><el-button type="primary" :loading="saving" @click="save">保存</el-button></span>
        </el-dialog>
        <el-dialog title="结束绑定" :visible.sync="ending" append-to-body custom-class="c-el-dialog asset-dialog asset-dialog--ending" :close-on-click-modal="false">
            <el-date-picker v-model="endDate" type="date" value-format="yyyy-MM-dd" :clearable="false" />
            <span slot="footer"><el-button :disabled="saving" @click="ending = false">取消</el-button><el-button type="primary" :loading="saving" @click="endBinding">确认结束</el-button></span>
        </el-dialog>
        <change-logs ref="logs" />
    </el-dialog>
</template>

<script>
    // 车架与保单绑定关系管理弹窗
    import moment from 'moment'
    import { bindingApi, policyApi, assetPermission } from '@/api/vehicleData'
    import permission from '@/mixins/permission'
    import enumConfigs from '@/mixins/enumConfigs'
    import ChangeLogs from './ChangeLogs'
    import assetResponsive from './assetResponsive'

    export default {
        components: { ChangeLogs },
        mixins: [permission, assetResponsive, enumConfigs],
        data() {
            return {
                visible: false, loading: false, editing: false, ending: false, saving: false,
                policy: null, policies: [], policyLoading: false, rows: [], total: 0, context: {},
                query: { page: 1, size: window.$common.appPageSize, chassisNo: '', policyNumber: '', currentOnly: false },
                form: {}, endingRow: null, endDate: '',
                rules: {
                    chassisNo: [{ required: true, message: '请输入车架号', trigger: 'blur' }],
                    policyNumber: [{ required: true, message: '请选择保单', trigger: 'change' }],
                    startDate: [{ required: true, message: '请选择开始日期', trigger: 'change' }]
                }
            }
        },
        computed: {
            canManage() { return this.hasSpecialRole(assetPermission('VehiclePolicyManage')) },
            canLogs() { return this.hasSpecialRole(assetPermission('VehicleDataChangeLog')) },
            title() { return `保险绑定 - ${this.context.policyNumber || this.context.chassisNo || ''}` }
        },
        methods: {
            date(value) { return value ? String(value).slice(0, 10) : '-' },
            async open(context, policy) {
                this.context = context
                this.policy = policy || null
                this.query = { page: 1, size: window.$common.appPageSize, chassisNo: '', policyNumber: '', currentOnly: false }
                this.rows = []
                this.total = 0
                this.visible = true
                if (policy) {
                    try { this.policy = await policyApi.detail(policy.id) } catch (_) { /* 请求层展示错误，保留列表中的保单数据。 */ }
                }
                this.load()
            },
            params() { return { ...this.query, ...this.context } },
            search() { this.query.page = 1; this.load() },
            async load() {
                this.loading = true
                try {
                    const result = await bindingApi.list(this.params())
                    this.rows = result.items || []
                    this.total = Number(result.totalCount || 0)
                } catch (_) { this.rows = []; this.total = 0 } finally { this.loading = false }
            },
            async searchPolicies(keywords) {
                this.policyLoading = true
                try {
                    const result = await policyApi.list({ keywords, page: 1, size: 100 })
                    this.policies = result.items || []
                    if (this.form.policyNumber && !this.policies.some(p => p.policyNumber === this.form.policyNumber)) this.policies.unshift({ policyNumber: this.form.policyNumber })
                } catch (_) { this.policies = [] } finally { this.policyLoading = false }
            },
            edit(row) {
                this.form = row ? { ...row, startDate: row.startDate ? this.date(row.startDate) : null, endDate: row.endDate ? this.date(row.endDate) : null } : {
                    chassisNo: this.context.chassisNo || '', policyNumber: this.context.policyNumber || '', insuranceArea: '', startDate: this.policy && this.policy.startDate ? this.date(this.policy.startDate) : null, endDate: null
                }
                this.policies = this.policy ? [this.policy] : this.form.policyNumber ? [{ policyNumber: this.form.policyNumber }] : []
                this.editing = true
                this.$nextTick(() => this.$refs.form.clearValidate())
                this.searchPolicies(this.form.policyNumber)
            },
            changePolicy(value) {
                const policy = this.policies.find(item => item.policyNumber === value)
                if (policy && policy.startDate) this.form.startDate = this.date(policy.startDate)
            },
            async save() {
                if (this.saving) return
                const valid = await this.$refs.form.validate().catch(() => false)
                if (!valid) return
                if (this.form.endDate && this.form.endDate < this.form.startDate) return this.$message.error('结束日期不能早于开始日期')
                this.saving = true
                try {
                    const { chassisNo, policyNumber, insuranceArea, startDate, endDate } = this.form
                    const input = { chassisNo, policyNumber, insuranceArea, startDate, endDate: endDate || null }
                    if (this.form.id) await bindingApi.update(this.form.id, input)
                    else await bindingApi.create(input)
                    this.editing = false
                    this.$message.success('绑定已保存')
                    await this.load()
                    const parallel = await bindingApi.list({ chassisNo, currentOnly: true, page: 1, size: 1 })
                    if (Number(parallel.totalCount) > 1) this.$message.warning('该车架有多个当前有效绑定，请核对重复投保情况')
                    this.$emit('changed')
                } catch (_) { /* 请求层展示保存失败原因，保留表单。 */ } finally { this.saving = false }
            },
            openEnd(row) { this.endingRow = row; this.endDate = moment().format('YYYY-MM-DD'); this.ending = true },
            async endBinding() {
                if (this.saving || !this.endDate) return
                if (this.endDate < this.date(this.endingRow.startDate)) return this.$message.error('结束日期不能早于开始日期')
                this.saving = true
                try {
                    await bindingApi.end(this.endingRow.id, this.endDate)
                    this.ending = false
                    this.$message.success('绑定结束日期已更新')
                    this.load()
                    this.$emit('changed')
                } catch (_) { /* 请求层展示错误。 */ } finally { this.saving = false }
            },
            async remove(row) {
                try {
                    await this.$confirm(`确认删除车架 ${row.chassisNo} 与保单 ${row.policyNumber} 的这条绑定？删除后不再保留该绑定历史。`, '删除绑定', { type: 'warning' })
                    await bindingApi.remove(row.id)
                    this.$message.success('绑定已删除')
                    this.load()
                    this.$emit('changed')
                } catch (_) { /* 取消和接口错误均保留列表。 */ }
            },
            // 车架保险日志以车架号为业务键精确查询
            showLogs(row) { this.$refs.logs.open(this.valVehicleDataChangeEntityTypeInsurance(), row.chassisNo) }
        }
    }
</script>
